import { get, post } from "@/utils/request";

// 获取开业申请列表
export const getOpenApplyList = (params: any) =>
  post("/api/companyBusiness/pagelist", params);
// 获取开业编辑详情
export const getOpenEditDetail = (params: any) =>
  post("/api/companyBusiness/detail", params);
// 开业审批
export const handleOpenApprove = (params: any) =>
  post("/api/companyBusiness/add", params);
// 撤回
export const handleOpendraw = (params: any) =>
  post("/api/companyBusiness/draw", params);
// 通过 驳回
export const handleGoOrReject = (params: any) =>
  post("/api/companyBusiness/approve", params);
// 设置对接财务和会计
export const handleSet = (params: any) =>
  post("/api/companyBusiness/set", params);

//获取开业详情信息
export const companyBusiness = (params: { Id: number | string }) =>
  post("/api/companyBusiness/detail", params);

//设置财务和会计
export const setDockingCashierName = (params: {
  Id: string;
  DockingCashierName: string;
  DockingAccountingName: string;
  DockingCashier: number;
  DockingAccounting: number;
}) => post("/api/companyBusiness/set", params);

//审批接口
export const approve = (params: {
  Description: string;
  WorkflowId: number;
  Status: number;
}) => post("/api/companyFlow/approve", params);

//获取会计和出纳
export const dockinglist = () => post("/api/staff/dockinglist");
